import { ReactNode } from "react";
import { ArrowRight } from "lucide-react";

interface AuthSubmitButtonProps {
  loading?: boolean;
  children: ReactNode;
  loadingText?: string;
  /** Disable the button without showing the loading spinner (e.g. while locked out). */
  disabled?: boolean;
}

export function AuthSubmitButton({ loading, children, loadingText, disabled }: AuthSubmitButtonProps) {
  return (
    <button
      type="submit"
      disabled={loading || disabled}
      aria-busy={loading}
      className="btn-electric group flex w-full items-center justify-center gap-2 rounded-xl px-6 py-3.5 text-sm font-semibold transition-transform hover:scale-[1.01] disabled:pointer-events-none disabled:opacity-60"
    >
      {loading ? (
        <>
          <span
            className="h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent"
            aria-hidden="true"
          />
          {loadingText ?? "Please wait…"}
        </>
      ) : (
        <>
          {children}
          <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5" />
        </>
      )}
    </button>
  );
}
